import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import coreEn from './en';
import coreDe from './de';

const resources = {
    en: { translation: coreEn },
    de: { translation: coreDe }
};

const savedLanguage = localStorage.getItem('language') || 'en';

i18n
    .use(initReactI18next)
    .init({
        fallbackLng: 'en',
        lng: savedLanguage,
        resources,
        ns: ['translation'],
        defaultNS: 'translation',
        // debug: true,               
        react: { useSuspense: false }
    });

i18n.languages = ['en', 'de'];

export default i18n;
